module.exports = __webpack_public_path__ + "img/ic-edit.e2279d23.svg";